export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7025.da1ddb1d.jpg";